import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  isSuccess: false,
};

const updateNotifications = (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.UPDATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
        success: '',
      };
    case actionConstants.UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isfetching: false,
        isSuccess: true,
        success: action.message,
      };
    case actionConstants.UPDATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
        isSuccess: false,
      };
    case actionConstants.UPDATE_NOTIFICATION_CLEAR_STATE:
      return {
        ...state,
        isfetching: false,
        isSuccess: false,
        success: '',
      };
    default:
      return state;
  }
};

export default updateNotifications;
